import React, { useEffect, useState } from 'react';

import './../assets/css/_autoCompleteCities.css';

interface AutoCompleteCitiesProps {
    citiesListData: string[],
    setAdressData: (name: string, e: any) => void,
    dataValue: string,
    field:string,
    disabled?: boolean;
    onBlur?: (value: any) => void;
}

const AutoCompleteCities: React.FC<AutoCompleteCitiesProps> = ({ citiesListData, setAdressData, dataValue, field,disabled,
    onBlur
}) => {
    const [inputValue, setInputValue] = useState(dataValue);
    const [suggestions, setSuggestions] = useState<string[]>([]);


    useEffect(() => {
        setInputValue(dataValue);
    }, [dataValue])
    

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if(field === 'city'){
            setAdressData(field, value);
            return ;
        } 
        setInputValue(value);
        setAdressData(field, value);

        if (value.length > 0) {
            const filteredSuggestions = citiesListData.filter((city) =>
                city.toLowerCase().includes(value.toLowerCase())
            );
            setSuggestions(filteredSuggestions);
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (suggestion: string) => {
        let val = suggestion.replace(/\s/g, '')
        setAdressData(field, val);
        setInputValue(suggestion);
        setSuggestions([]);
    };

    const handleInputBlur = () => {
        // setTimeout(() => {
        //     setSuggestions([]);
        // }, 200);
        if(onBlur){
            onBlur(inputValue)
        }
    };

    const handleInputFocus = () => {
        if (inputValue.length > 0) {
            const filteredSuggestions = citiesListData.filter((city) =>
                city.toLowerCase().includes(inputValue.toLowerCase())
            );
            setSuggestions(filteredSuggestions);
        }
    };

    return (
        <div className="city-autocomplete">
            <input disabled ={disabled}
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                // onFocus={handleInputFocus}
                className="autocomplete-input"
                placeholder='שדה חובה*'
                // placeholder="Search for a city..."
            />
            {suggestions.length > 0 && (
                <ul className="suggestions-list">
                    {suggestions.map((suggestion, index) => (
                        <li className="suggestion-item"  key={index} onClick={() => handleSuggestionClick(suggestion)}>
                            {suggestion}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default AutoCompleteCities